<template>
  <div class="cardContentTableDiv ">
    <highcharts :options="chartOptions"></highcharts>
  </div>
</template>


<script>
import Highcharts from "highcharts";
import exportingInit from "highcharts/modules/exporting";
import stockInit from "highcharts/modules/stock";

exportingInit(Highcharts);
stockInit(Highcharts)

export default {
  name: "DashboardRevenueChart",
  props: ["chartId", "title", "subTitle","chartTitleStyle","chartSubTitleStyle","chartStyle","categories","chartSeries"],
  data() {
    return {
      chartOptions: {
        chart: {
          type: "spline",
          style: this.chartStyle,
          height: "300px",
        },
        title: {
          text: this.title,
          align: "left",
          style: this.chartTitleStyle
        },

        // subtitle: {
        //   text: "Monthly Subscriptions",
        //   align: "left",
        //   y: 14,
        //   x: 100,
        //   style: {
        //     "font-family": "Futura LT",
        //     "font-weight": "400",
        //     "font-size": "16px",
        //     "line-height": "19px",
        //     color: "#656565 ",
        //     float: "left",
        //   },
        // },

        yAxis: {
          title: {
            text: "Revenue",
            align: "high",
            offset: 0,
            rotation: 0,
            y: -15,
          },
        },

        legend: {
          layout: "horizontal",
          //align: "center",
          verticalAlign: "top",
        },

        plotOptions: {
          spline: {
            dataLabels: {
              enabled: false,
            },
            enableMouseTracking: true,
          },

          series: {
            label: {
              // enabled: true,
              connectorAllowed: false,
            },
            // marker: {
            //  enabled: true
            // }
          },
        },

    scrollbar: {
        enabled: true
    },
        xAxis: {
          categories: this.categories,
          max: 6,
          title:{
              text:"Subs",
              align: "low",
              y:-22,
              x:-30
          }
        },
        credits: {
          enabled: false,
        },
        series: this.chartSeries,
        responsive: {
          rules: [
            {
              condition: {
                maxWidth: 500,
              },
              chartOptions: {
                legend: {
                  layout: "horizontal",
                },
              },
            },
          ],
        },
      },
    };
  },
};
</script>
<style scoped>
</style>


// WEBPACK FOOTER //
// src/components/dashboard/RevenueChart.vue